import styled from 'styled-components';
import { rem } from 'polished';

const UseToolsContainer = styled.div`
    margin: ${rem(16)} 0;
`;

export default UseToolsContainer;
